import React from "react";
import { PageContent, CustomBreadcrumb } from "components/Common";

import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import MasterInstrumentType from "./MasterInstrumentType";

const RESOURCE = ModuleIds.MasterInstrumentType;

const MasterInstrumentTypeContainer = ({ t }) => {
  const titleTag = t("Danh sách Master Instrument Type");

  return (
    <PageContent title={t(titleTag)}>
      {/* Page Title */}
      <CustomBreadcrumb
        breadcrumbItem={titleTag}
        resource={RESOURCE}
        icon={<i className="bx bx-file" />}
      />
      {/* Page Body */}
      <MasterInstrumentType />
    </PageContent>
  );
};

MasterInstrumentTypeContainer.propTypes = {
  t: PropTypes.any,
};

export default withTranslation(["masterInstrumentTypePage"])(
  MasterInstrumentTypeContainer
);
